<template>
  <div class="page">
    <h3>공통 코드</h3>

    <div class="toolbar">
      <label>타입</label>
      <select v-model="type">
        <option value="">선택하세요</option>
        <option v-for="t in types" :key="t" :value="t">{{ t }}</option>
      </select>
      <button @click="reload">조회</button>
      <span class="spacer"></span>
      <button class="ghost" @click="uploadOpen=true">은행코드 업로드</button>
    </div>

    <div class="table-scroll">
      <table class="grid">
        <thead>
          <tr>
            <th>타입</th><th>이름</th><th>값</th><th>범위 시작</th><th>범위 끝</th><th>정렬 번호</th>
            <th>메모1</th><th>메모2</th><th>메모3</th><th>등록일시</th><th>수정일시</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(r, i) in rows" :key="i">
            <td>{{ r.type }}</td>
            <td>{{ r.name }}</td>
            <td>{{ r.val }}</td>
            <td class="num">{{ r.rangeFrom }}</td>
            <td class="num">{{ r.rangeTo }}</td>
            <td class="num">{{ r.sortNo }}</td>
            <td>{{ r.ref1 }}</td>
            <td>{{ r.ref2 }}</td>
            <td>{{ r.ref3 }}</td>
            <td>{{ r.regDt }}</td>
            <td>{{ r.updDt }}</td>
          </tr>
          <tr v-if="rows.length===0"><td colspan="11" class="empty">데이터가 없습니다.</td></tr>
        </tbody>
      </table>
    </div>

    <Paging :page="page" :size="size" :total-count="total" :total-pages="totalPages"
            @change-page="onPage" @change-size="onSize" />

    <BankCodeUploadDialog v-if="uploadOpen" @uploaded="onUploaded" @close="uploadOpen=false" />
  </div>
</template>

<script>
import api from '../api';
import Paging from '../components/Paging.vue';
import BankCodeUploadDialog from '../components/BankCodeUploadDialog.vue';

export default {
  name: 'ComCodeView',
  components: { Paging, BankCodeUploadDialog },
  data() {
    return { types: [], type: '', rows: [], page: 1, size: 20, total: 0, uploadOpen: false };
  },
  computed: { totalPages() { return Math.max(1, Math.ceil(this.total / this.size)); } },
  async created() {
    try { const t = await api.comCodeTypes(); this.types = t.data || []; } catch (e) { this.types = []; }
    this.reload();
  },
  methods: {
    async load() {
      try {
        const res = await api.comCodeList({ type: this.type, page: this.page, size: this.size });
        const d = res.data || {};
        this.rows = d.rows || [];
        this.total = d.total || 0;
      } catch (e) { this.rows = []; this.total = 0; }
    },
    reload() { this.page = 1; this.load(); },
    onPage(p) { this.page = p; this.load(); },
    onSize(s) { this.size = s; this.page = 1; this.load(); },
    async onUploaded() {
      this.uploadOpen = false;
      try { const t = await api.comCodeTypes(); this.types = t.data || []; } catch (e) { /* noop */ }
      this.reload();
    }
  }
};
</script>

<style scoped>
.page { background: #fff; padding: 20px; border-radius: 8px; }
h3 { margin: 0 0 16px; }
.toolbar { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; margin-bottom: 14px; }
.toolbar label { font-size: 13px; color: #555; }
.toolbar select { padding: 7px 9px; border: 1px solid #d0d5dd; border-radius: 5px; }
.toolbar .spacer { flex: 1; }
.toolbar button { padding: 7px 16px; background: #2f6fed; color: #fff; border: none; border-radius: 5px; cursor: pointer; }
.toolbar button.ghost { background: #eef1f7; color: #33415c; }
.table-scroll { overflow-x: auto; }
.grid { width: 100%; border-collapse: collapse; min-width: 1100px; }
.grid th, .grid td { border: 1px solid #e5e8ef; padding: 8px 10px; font-size: 13px; white-space: nowrap; }
.grid th { background: #f0f3fa; color: #33415c; }
.grid td.num { text-align: right; }
.empty { text-align: center; color: #999; padding: 20px; }
</style>
